import React from 'react';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '../../../theme/ThemeProvider';

type ThemeToggleProps = {
  className?: string;
  showLabel?: boolean;
};

const ThemeToggle: React.FC<ThemeToggleProps> = ({
  className = '',
  showLabel = false,
}) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className={`theme-toggle ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? <SunOutlined /> : <MoonOutlined />}
      {showLabel && <span>{isDark ? 'Light' : 'Dark'}</span>}
    </button>
  );
};

export default ThemeToggle;
